import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface OrderConditionReadOnlyFieldProps {
  label: LangEnum;
  value?: string;
}

const OrderConditionReadOnlyField = ({ label, value }: OrderConditionReadOnlyFieldProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ gap: 0.25, minWidth: 0 }}>
      <Typography variant="micro1" sx={{ color: 'text.secondary' }}>
        {translate(label)}
      </Typography>
      <Typography variant="body2" sx={{ color: value ? 'text.primary' : 'text.disabled' }}>
        {value || translate(LangEnum.GLOBAL_NO_INFORMATIONS)}
      </Typography>
    </Stack>
  );
};

export default OrderConditionReadOnlyField;
